module.exports = __webpack_public_path__ + "img/1.7de2e613.jpg";